import { Box, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import { useCustomColors } from "../../hooks/useCustomColors";
import { useTranslation } from "react-i18next";

export const MOBILE_NAV_HEIGHT = 76;

const NAV_ITEMS = [
  { labelKey: "nav_home", href: "/", icon: HomeRoundedIcon },
  { labelKey: "nav_play", href: "/game/bet", icon: SportsEsportsRoundedIcon },
  { labelKey: "nav_history", href: "/history", icon: ReceiptLongRoundedIcon },
];

const MobileBottomNav = () => {
  const colors = useCustomColors();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: { xs: "block", md: "none" },
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        px: "12px",
        pb: "calc(12px + env(safe-area-inset-bottom))",
      }}
    >
      <Stack
        direction="row"
        sx={{
          borderRadius: "22px",
          border: `1px solid ${colors.border.accent}`,
          backgroundColor: colors.background.bar,
          backdropFilter: "blur(16px)",
          boxShadow: "0 -8px 32px rgba(7, 7, 7, 0.78)",
          overflow: "hidden",
        }}
      >
        {NAV_ITEMS.map((item) => {
          const isActive =
            item.href === "/"
              ? pathname === "/"
              : pathname.startsWith(item.href);
          const Icon = item.icon;
          return (
            <Box
              key={item.href}
              onClick={() => navigate(item.href)}
              sx={{
                flex: 1,
                py: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
                position: "relative",
                color: isActive ? "#FFFFFF" : colors.text.secondary,
                background: isActive ? colors.gradient.brand : "none",
                boxShadow: isActive ? colors.gradient.brandGlow : "none",
                "&::before": isActive
                  ? {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: "18%",
                      right: "18%",
                      height: "2px",
                      backgroundColor: colors.accent.gold,
                    }
                  : undefined,
              }}
            >
              <Icon sx={{ fontSize: "20px" }} />
              <Typography
                sx={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px" }}
              >
                {t(item.labelKey)}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default MobileBottomNav;
